import React from 'react';

import numberFormatter from '../../../common/numberFormatter';
import CopyButton from '../../../common/components/CopyButton/CopyButton';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { SumData } from './contractEstimateItemGridUtils';

interface ContractEstimateItemPositionsGridProps {
  sumData: SumData;
}

export const ContractEstimateItemPositionsGridSum: React.FC<
  ContractEstimateItemPositionsGridProps
> = props => {
  const { t, tk } = useTranslation('projectLng');
  const {
    contractAmount,
    positionsNotAssignedSum,
    positionsTotalSum: positionsTotalSum,
    contractSettledAmount,
    contractUnsettledAmount,
  } = props.sumData;

  return (
    <>
      <tr>
        <td colSpan={4} className="bold">
          {t(tk.common.sumUpperCase)}:
        </td>
        <td className="bold amounts-align-right">
          {numberFormatter(positionsTotalSum, true)}
        </td>
        <td className="bold amounts-align-right">
          {numberFormatter(positionsNotAssignedSum, true)}
        </td>
        <td />
        <td className="bold">{numberFormatter(contractSettledAmount, true)}</td>
      </tr>
      <tr>
        <td colSpan={7} className="bold">
          {t(tk.contract.contractAmountUppercase)}:
        </td>
        <td className="bold">{numberFormatter(contractAmount, true)}</td>
      </tr>
      <tr>
        <td colSpan={7} className="bold align-middle">
          {t(tk.contract.unsettledAmountUppercase)}:
        </td>
        <td className="bold">
          {numberFormatter(contractUnsettledAmount, true)}
          <CopyButton value={numberFormatter(contractUnsettledAmount)} />
        </td>
      </tr>
    </>
  );
};
